import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div class="InvoiceLayout">
            <div class="wrapper wrapper--1320">
                <div class="InvoiceLayout__body">
                    <slot></slot>
                </div>
            </div>
        </div>
    `,
});
